// eslint-disable-next-line
__webpack_public_path__ = `${window.VCSTATE.ASSETS_PATH}/packs/`;
